import React from "react"
import ReactDOM from "react-dom"
import AirlineList from "./airline-list"

export default class AirlineListModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.airlines = elem.dataset.airlines && JSON.parse(elem.dataset.airlines)
    self.zeroStateAirlines = elem.dataset.zeroStateAirlines && JSON.parse(elem.dataset.zeroStateAirlines)
    self.textKeys = elem.dataset.textKeys && JSON.parse(elem.dataset.textKeys)
    self.language = (document.body && document.body.dataset.language) || "da"
    this.init()
    return self
  }
  init() {
    const self = this
    ReactDOM.render(
      <AirlineList {...self.textKeys} airlines={self.airlines} zeroStateAirlines={self.zeroStateAirlines} language={self.language} />,
      self.elem,
    )
  }
}
